import React, {Component} from 'react';
import {connect} from 'react-redux';
import Head from '../../Structure/components/Head/Head';
import Footer from '../../Structure/components/Footer/Footer';
import EntityListContainer from './EntityListContainer';
import {getAllEntities, getEntitiesByFilter} from '../actions/actionsEntities'
import Alert from 'react-s-alert';
import AlertsConteiner from '../../Shared/components/Alerts/AlertsConteiner';
import WaitBlock from "../../Shared/components/Alerts/WaitBlock";
import {
    changeConfigFiltroEntity,
    changefiltroEntitySeleccionado,
    loadMunicipiosByProvincia,
    loadProvincias,
    resetFilterEntities,
} from "../actions/actionsFilterEntities";
import {browserHistory} from "react-router";
import {
    PATH_BUSCADOR_PETFRIENDLY_DETAIL_PERMALINK_PATTERN,
    PATH_BUSCADOR_PETFRIENDLY_PROVINCIA,
    PATH_BUSCADOR_PETFRIENDLY_PROVINCIA_MUNICIPIO,
    PATH_BUSCADOR_PETFRIENDLY_ROOT,
    PATH_BUSCADOR_PETFRIENDLY_TIPO,
    PATH_BUSCADOR_PETFRIENDLY_TIPO_PROVINCIA_MUNICIPIO,
    PATH_BUSCADOR_PETFRIENDLY_TIPO_SUBTIPO,
    PATH_BUSCADOR_PETFRIENDLY_TIPO_SUBTIPO_PROVINCIA,
    PATH_BUSCADOR_PETFRIENDLY_TIPO_SUBTIPO_PROVINCIA_MUNICIPIO
} from "../../../App/RouterAdopta";
import _ from "lodash"
import Breadcrumbs_component from "../../Shared/components/components/Breadcrumbs/Breadcrumbs_component";
import {coordsDistance, getCurrentLocationCoordinates} from "../../../Utils/GeoCoding";
import ShareButtonsBox from "../../Shared/components/SocialMediaButtons/ShareButtonsBox";
import {sendEvent} from "../../../analytics/analitycs"

import {
    ELEMENTS_PER_PAGE_DESKTOP,
    ELEMENTS_PER_PAGE_MOBILE,
    ELEMENTS_PER_PAGE_TABLET,
    ELEMENTS_PER_ROW_DESKTOP,
    ELEMENTS_PER_ROW_MOBILE,
    ELEMENTS_PER_ROW_TABLET,
    MAP_SUBTIPOS_ENTITY_CONFIG,
    MAP_TIPOS_ENTITY,
    MOBILE_MAX_WINDOW_WIDTH,
    TABLET_MAX_WINDOW_WIDTH
} from '../../../config/globalFrontEndConfig.js'
import {capitalizeFirstLetter, plurifyFirstWord} from "../../../Utils/Analizer";
import {Helmet} from "react-helmet";
import FAQs_component from "../../Shared/components/components/FAQs/FAQs_component";
import {ELEMENTS, TIPOS_EVENTOS} from "../../../analytics/config/analyticsParamsFrontEnd";
import {arrayEquals} from "../../../Utils/utils";
import {ADS_TYPES, AdsManagerContainer} from "../../Ads/components/AdsManagerContainer";


let userLocation

const initialState_FiltroEntitySeleccionado = {
    tipo: undefined, subtipo: undefined, geo: {
        provincia: undefined, municipio: undefined, near: false, userLocation: {}, geoInBounds: {}
    }
};

class EntityListPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            config: props.config || {},
            filtroEntitySeleccionado: props.filtroEntitySeleccionado || initialState_FiltroEntitySeleccionado,
            currentElementHoverId: undefined
        }
        //console.log("EntityListPage::constructor()");

        this.loadFilterSeleccionadoFromURLParams(props.params)
        let hashValid = false
        if (props?.location?.hash && ["#mapa", "#listing"].includes(props.location.hash)) {
            hashValid = true
        }

        //TODO 24/2/22 17:00: probar a guardar en el store la config de elementos por pagina y row
        const width = window.innerWidth;
        if (width < MOBILE_MAX_WINDOW_WIDTH) {
            // console.log("EntityListPage::constructor() load config mobile");
            this.state.config.elementsPerPage = ELEMENTS_PER_PAGE_MOBILE;
            this.state.config.elementsPerRow = ELEMENTS_PER_ROW_MOBILE;
            if (hashValid && props.location.hash === "#mapa") {
                this.state.config.showListing = false
                this.state.config.showMap = true
            } else {
                this.state.config.showListing = true
                this.state.config.showMap = false
            }
            this.state.config.mobileMode = true
        } else if (width >= MOBILE_MAX_WINDOW_WIDTH && width < TABLET_MAX_WINDOW_WIDTH) {
            // console.log("EntityListPage::constructor() load config table");
            this.state.config.elementsPerPage = ELEMENTS_PER_PAGE_TABLET;
            this.state.config.elementsPerRow = ELEMENTS_PER_ROW_TABLET;
            if (hashValid && props.location.hash === "#mapa") {
                this.state.config.showListing = false
                this.state.config.showMap = true
            } else {
                this.state.config.showListing = true
                this.state.config.showMap = false
            }
            this.state.config.mobileMode = true
        } else {
            this.state.config.elementsPerPage = ELEMENTS_PER_PAGE_DESKTOP;
            this.state.config.elementsPerRow = ELEMENTS_PER_ROW_DESKTOP;
            this.state.config.showListing = true;
            this.state.config.showMap = true;
            this.state.config.mobileMode = false
        }
        //console.log("EntityListPage::onChangeFilter() -> call changefiltroEntitySeleccionado");

        this.props.changefiltroEntitySeleccionado(this.state.filtroEntitySeleccionado);

        let request = {
            filter: this.state.filtroEntitySeleccionado,
            metadata: {
                numElements: this.state.config.elementsPerPage,
                pagNum: this.state.config.pagNum,
                firstRequest: true
            }
        };
        //console.log("EntityListPage::constructor() -> call getEntitiesByFilter");
        //TODO 11/2/23 11:23: meter qui un useViewerLocation para que solo la primera query sea geo localizada
        this.props.getEntitiesByFilter(request)
        setTimeout(() => {
            // console.log("EntityListPage::constructor() -> sendEvent pageview");
            // console.log({permalink: props.location.pathname});
            sendEvent(TIPOS_EVENTOS.PAGEVIEW, ELEMENTS.BUSCADOR.BUSCADOR, {permalink: props.location.pathname})
            sendEvent(TIPOS_EVENTOS.SEARCH, ELEMENTS.BUSCADOR.BUSCADOR, {
                ...request, config: {
                    mobileMode: this.state.config.mobileMode,
                    showMap: this.state.config.showMap,
                    showListing: this.state.config.showListing
                }
            })
        }, 5 * 1000)

        $('body,html').stop(true, true).animate({scrollTop: 0}, 0);


        this.loadFilterSeleccionadoFromURLParams = this.loadFilterSeleccionadoFromURLParams.bind(this);
        this.handleLocationError = this.handleLocationError.bind(this);
        this.onClickPagination = this.onClickPagination.bind(this);
        this.onClickShareButton = this.onClickShareButton.bind(this);
        this.onSearchCurrentLocation = this.onSearchCurrentLocation.bind(this);
        this.onSearchInBoundsLocation = this.onSearchInBoundsLocation.bind(this);
        this.onChangeFilter = this.onChangeFilter.bind(this);
        this.showLoader = this.showLoader.bind(this);
        this.onShowMap = this.onShowMap.bind(this);
        this.onShowListing = this.onShowListing.bind(this);
        this.onMouseOverElement = this.onMouseOverElement.bind(this);
        this.onClickCardListing = this.onClickCardListing.bind(this);
        this.onClickCardMap = this.onClickCardMap.bind(this);
        this.handleWindowResize = this.handleWindowResize.bind(this);
        this.changePath = this.changePath.bind(this);
        this.formatTitleFromFilter = this.formatTitleFromFilter.bind(this);
    }

    loadFilterSeleccionadoFromURLParams(URLParams) {
        console.log("EntityListPage::loadFilterSeleccionadoFromURLParams()");
        let tipo_entity, subtipo_entity, provincia, municipio;

        //TODO 10/3/22 23:21: todo esto hay que hacerlo bien y con suabidad por que son muchas casuisticas distintas,
        // igual nos podemos ayudar de prefijos en los params para identifica el caso pj: .../en-madrid/...
        if (URLParams.pagina && Number.isInteger(parseInt(URLParams.pagina))) {
            let num = parseInt(URLParams.pagina)
            this.state.config.pagNum = (num > 1) ? num - 1 : 0
        } else {
            this.state.config.pagNum = 0
        }


        if (!URLParams.tipo_entity) {
            this.state.filtroEntitySeleccionado.tipo = ["protectora"]
            this.state.filtroEntitySeleccionado.subtipo = []
        } else {
            if (!Object.keys(MAP_TIPOS_ENTITY).includes(URLParams.tipo_entity.toLowerCase())) {
                // console.log("Tipo entidad no valido -> to /buscar-pet-friendly");
                this.state.filtroEntitySeleccionado.tipo = ["protectora"]
                this.state.filtroEntitySeleccionado.subtipo = []
                // browserHistory.push("/buscar-pet-friendly")
            } else {
                tipo_entity = URLParams.tipo_entity.toLowerCase()
                this.state.filtroEntitySeleccionado.tipo = (tipo_entity) ? [tipo_entity] : [];
                if (!URLParams.subtipo_entity) {
                    this.state.filtroEntitySeleccionado.subtipo = []
                } else {
                    let aux_subtipo = URLParams.subtipo_entity.toLocaleString().replace(" ", "-").split(",")
                    let aux_subtipo_valid = aux_subtipo.filter(st => MAP_SUBTIPOS_ENTITY_CONFIG[tipo_entity][st])
                    this.state.filtroEntitySeleccionado.subtipo = aux_subtipo_valid;
                    // if (aux_subtipo_valid.length === 0) {
                    //     browserHistory.push(PATH_BUSCADOR_PETFRIENDLY_TIPO.replace(":tipo_entity", tipo_entity))
                    // }
                    // if (MAP_SUBTIPOS_ENTITY_CONFIG[tipo_entity][aux_subtipo]) {
                    //     subtipo_entity = aux_subtipo
                    //     this.state.filtroEntitySeleccionado.subtipo = (subtipo_entity) ? subtipo_entity : [];
                    // } else {
                    //     this.state.filtroEntitySeleccionado.subtipo = []
                    //     // console.log("Subtipo entidad no valido -> to /buscador/" + tipo_entity);
                    //     browserHistory.push(PATH_BUSCADOR_PETFRIENDLY_TIPO.replace(":tipo_entity",tipo_entity))
                    // }
                }
            }
        }
        //TODO 10/3/22 23:22: es para provar, igual habria que validar o dejarselo al backend mejor desde aqui
        // podemos hacer redireccion si está mal, pero se engorrona un poco el front
        // console.log("params.provincia = '" + params.provincia + "'");
        if (URLParams.provincia) {
            provincia = URLParams.provincia.toLowerCase()
            this.state.filtroEntitySeleccionado.geo.provincia = provincia;
            if (!this.state.filtroEntitySeleccionado.geo.userLocation) this.state.filtroEntitySeleccionado.geo.userLocation = {};
            this.state.filtroEntitySeleccionado.geo.userLocation.useUserLocation = false;
        } else {
            this.state.filtroEntitySeleccionado.geo.provincia = undefined
        }
        //console.log("URLParams.municipio = '" + URLParams.municipio + "'");

        if (URLParams.municipio?.toLowerCase() === "mi") {
            if (!this.state.filtroEntitySeleccionado.geo.userLocation) this.state.filtroEntitySeleccionado.geo.userLocation = {};
            this.state.filtroEntitySeleccionado.geo.userLocation.queryCercaDeMi = true;
            this.state.filtroEntitySeleccionado.geo.userLocation.useUserLocation = true;
            this.onSearchCurrentLocation()
        } else if (URLParams.municipio) {
            this.state.filtroEntitySeleccionado.geo.municipio = URLParams.municipio.toLowerCase();
            this.state.filtroEntitySeleccionado.geo.near = true;
            this.state.filtroEntitySeleccionado.geo.maxDistance = 45;
            if (!this.state.filtroEntitySeleccionado.geo.userLocation) this.state.filtroEntitySeleccionado.geo.userLocation = {};
            this.state.filtroEntitySeleccionado.geo.userLocation.useUserLocation = false;
            if (!this.state.filtroEntitySeleccionado.geo.geoInBounds) this.state.filtroEntitySeleccionado.geo.geoInBounds = {};
            this.state.filtroEntitySeleccionado.geo.geoInBounds.useGeoInBounds = false;
        } else {
            this.state.filtroEntitySeleccionado.geo.municipio = undefined;
            this.state.filtroEntitySeleccionado.geo.userLocation = {
                useUserLocation: false,
                queryCercaDeMi: false
            }
        }

        //console.log("this.state.filtroEntitySeleccionado");
        //console.log(this.state.filtroEntitySeleccionado);
    }

    showLoader() {

    }

    changePath(resultFilter, metadata) {
        //console.log("EntityListPage::changePath()");
        let newPATH
        //tipo subtipo prov mun
        const allSubtipos = resultFilter.tipo[0] && resultFilter.subtipo.length === Object.keys(MAP_SUBTIPOS_ENTITY_CONFIG[resultFilter.tipo[0]]).length

        if (resultFilter.tipo.length === 1 && resultFilter.subtipo.length > 0 && resultFilter.geo.provincia) {
            newPATH = (PATH_BUSCADOR_PETFRIENDLY_TIPO_SUBTIPO_PROVINCIA_MUNICIPIO
                .replace(":tipo_entity", resultFilter.tipo[0].toLowerCase())
                .replace(":subtipo_entity", (allSubtipos ? undefined : resultFilter.subtipo.sort().join(',').toLowerCase()))
                .replace(":provincia", resultFilter.geo.provincia.toLowerCase())
                .replace(":municipio", resultFilter.geo?.municipio?.toLowerCase()))
        }

        //tipo subtipo prov
        // if (resultFilter.tipo.length === 1 && resultFilter.subtipo.length > 0 && resultFilter.geo.provincia && !resultFilter.geo.municipio) {
        //     newPATH = (PATH_BUSCADOR_PETFRIENDLY_TIPO_SUBTIPO_PROVINCIA
        //         .replace(":tipo_entity", resultFilter.tipo[0].toLowerCase())
        //         .replace(":subtipo_entity", resultFilter.subtipo.join(',').toLowerCase())
        //         .replace(":provincia", resultFilter.geo.provincia.toLowerCase()))
        // }

        //tipo subtipo
        if (resultFilter.tipo.length === 1 && resultFilter.subtipo.length > 0 && !resultFilter.geo.provincia && !resultFilter.geo.municipio) {
            newPATH = (PATH_BUSCADOR_PETFRIENDLY_TIPO_SUBTIPO
                .replace(":tipo_entity", resultFilter.tipo[0].toLowerCase())
                .replace(":subtipo_entity", (allSubtipos ? undefined : resultFilter.subtipo.sort().join(',').toLowerCase())))
        }

        //tipo prov mun
        if (resultFilter.tipo.length === 1 && resultFilter.subtipo.length === 0 && resultFilter.geo.provincia) {
            newPATH = (PATH_BUSCADOR_PETFRIENDLY_TIPO_PROVINCIA_MUNICIPIO
                .replace(":tipo_entity", resultFilter.tipo[0].toLowerCase())
                .replace(":provincia", resultFilter.geo.provincia.toLowerCase())
                .replace(":municipio", resultFilter.geo.municipio?.toLowerCase()))
        }
        //tipo prov
        // if (resultFilter.tipo.length === 1 && resultFilter.subtipo.length === 0 && resultFilter.geo.provincia && !resultFilter.geo.municipio) {
        //     newPATH = (PATH_BUSCADOR_PETFRIENDLY_TIPO_PROVINCIA
        //         .replace(":tipo_entity", resultFilter.tipo[0].toLowerCase())
        //         .replace(":provincia", resultFilter.geo.provincia.toLowerCase()))
        // }
        //tipo
        if (resultFilter.tipo.length === 1 && resultFilter.subtipo.length === 0 && !resultFilter.geo.provincia && !resultFilter.geo.municipio) {
            newPATH = (PATH_BUSCADOR_PETFRIENDLY_TIPO
                .replace(":tipo_entity", resultFilter.tipo[0].toLowerCase()))
        }
        //prov mun
        if (resultFilter.tipo.length !== 1 && resultFilter.subtipo.length === 0 && resultFilter.geo.provincia) {
            newPATH = (PATH_BUSCADOR_PETFRIENDLY_PROVINCIA_MUNICIPIO
                .replace(":provincia", resultFilter.geo.provincia.toLowerCase())
                .replace(":municipio", resultFilter.geo.municipio?.toLowerCase()))
        }
        //prov
        // if (resultFilter.tipo.length !== 1 && resultFilter.subtipo.length === 0 && resultFilter.geo.provincia && !resultFilter.geo.municipio) {
        //     newPATH = (PATH_BUSCADOR_PETFRIENDLY_PROVINCIA
        //         .replace(":provincia", resultFilter.geo.provincia.toLowerCase()))
        // }
        if (resultFilter?.geo?.userLocation?.useUserLocation) {
            if (resultFilter?.geo?.provincia) {
                newPATH = PATH_BUSCADOR_PETFRIENDLY_TIPO_SUBTIPO_PROVINCIA_MUNICIPIO
                    .replace(":tipo_entity", resultFilter.tipo[0]?.toLowerCase())
                    .replace(":subtipo_entity", (allSubtipos ? undefined : resultFilter.subtipo.sort().join(',').toLowerCase()))
                    .replace(":provincia", resultFilter?.geo?.provincia?.toLowerCase());
                newPATH = newPATH.replace(":municipio", "mi")
                    .replace(/\/((:[a-z]*-[a-z]*_?[a-z]*)|(undefined))/gmi, "")

            } else {
                newPATH = PATH_BUSCADOR_PETFRIENDLY_TIPO_SUBTIPO
                    .replace(":tipo_entity", resultFilter.tipo[0]?.toLowerCase())
                    .replace(":subtipo_entity", (allSubtipos ? undefined : resultFilter.subtipo.sort().join(',').toLowerCase()))
                newPATH = newPATH + (newPATH.endsWith("/") ? "" : "/") + "cerca-de-mi"
            }
            newPATH = newPATH.replace(/\/((:[a-z]*-[a-z]*_?[a-z]*)|(undefined))/gmi, "")
        }

        newPATH = newPATH.replace(/\/(([a-z]*-[a-z]*_?[a-z]*-undefined)|(undefined))/gmi, "")

        if (metadata?.pagNum > 0) {
            newPATH = newPATH + "/pag-" + (metadata.pagNum + 1)
        }
        browserHistory.push(newPATH || PATH_BUSCADOR_PETFRIENDLY_ROOT)

    }

    onChangeFilter(filtroEntitySeleccionado) {
        //console.log("EntityListPage::onChangeFilter() -> municipio = '" + filtroEntitySeleccionado?.geo?.municipio + "'");
        let useViewerLocation
        const resultFilter = _.cloneDeep(Object.assign(this.state.filtroEntitySeleccionado, filtroEntitySeleccionado))
        if (resultFilter?.geo?.provincia) {
            if (!this.props.paramsFilter.municipios || !this.props.paramsFilter.municipios[resultFilter?.geo?.provincia]) {
                this.props.loadMunicipiosByProvincia(resultFilter?.geo?.provincia)
            }
            useViewerLocation = false
        }

        if (resultFilter?.geo?.municipio) {
            resultFilter.geo.near = true
            resultFilter.geo.maxDistance = 35
            useViewerLocation = false
        }
        if (resultFilter?.geo?.geoInBounds) {
            useViewerLocation = false
        }
        if (resultFilter?.geo?.userLocation) {
            useViewerLocation = false
        }
        this.changePath(resultFilter)

        let request = {
            filter: resultFilter,
            metadata: {
                numElements: this.state.config.elementsPerPage,
                pagNum: 0,
                useViewerLocation
            }
        };
        this.props.getEntitiesByFilter(request)
        this.props.changefiltroEntitySeleccionado(resultFilter);

        sendEvent(TIPOS_EVENTOS.SEARCH, ELEMENTS.BUSCADOR.BUSCADOR, {
            ...request, config: {
                mobileMode: this.state.config.mobileMode,
                showMap: this.state.config.showMap,
                showListing: this.state.config.showListing
            }
        })
    }


    onShowListing() {
        //console.log("EntityListPage::onShowListing()");
        const configResult = Object.assign(this.state.config, {
            showMap: false, showListing: true
        })

        this.setState({
            config: configResult
        }, () => {
            // console.log("state config cambiada");
            this.props.changeConfigFiltroEntity(this.state.config);
        })

    }

    onShowMap() {
        const configResult = Object.assign(this.state.config, {
            showMap: true, showListing: false
        })

        this.setState({
            config: configResult
        }, () => {
            // console.log("state config cambiada");
            this.props.changeConfigFiltroEntity(this.state.config);
        })
    }


    onSearchCurrentLocation() {
        console.log("EntityListPage::onSearchCurrentLocation()");
        const that = this
        getCurrentLocationCoordinates((position) => {
            if (position) {
                const pos = {
                    lat: position.coords.latitude, lng: position.coords.longitude,
                };
                localStorage.setItem('viewerLatLng', JSON.stringify(pos));

                let filtroEntitySeleccionado = {
                    ...that.state.filtroEntitySeleccionado, geo: {
                        geoInBounds: undefined, userLocation: {
                            useUserLocation: true,
                            lat: position.coords.latitude,
                            lng: position.coords.longitude,
                            maxDistance: 30
                        }, // provincia: undefined,
                        // municipio: undefined
                    },
                }
                this.changePath(filtroEntitySeleccionado)

                let request = {
                    filter: filtroEntitySeleccionado, metadata: {
                        numElements: that.state.config.elementsPerPage, pagNum: that.state.config.pagNum,
                    }
                };

                //console.log("EntityListPage::onSearchCurrentLocation() -> call getEntitiesByFilter");
                this.props.getEntitiesByFilter(request)
                //console.log("EntityListPage::onChangeFilter() -> call changefiltroEntitySeleccionado");

                this.props.changefiltroEntitySeleccionado(filtroEntitySeleccionado);
                sendEvent(TIPOS_EVENTOS.SEARCH, ELEMENTS.BUSCADOR.BUSCADOR, {
                    ...request, config: {
                        mobileMode: that.state.config.mobileMode,
                        showMap: that.state.config.showMap,
                        showListing: that.state.config.showListing
                    }
                })
            }
        }, (browserHasGeolocation) => that.handleLocationError(browserHasGeolocation))
    }

    handleLocationError(browserHasGeolocation) {
        //console.log("EntityListPage::handleLocationError()");
        let errorGetGeoLocation = browserHasGeolocation
            ? "Error: La geolocalización falló. Es necesario dar permisos de ubicación para buscar cerca de ti 📍"
            : "Error: Tu navegador no soporta la geolocalización. 😿"

        Alert.error(errorGetGeoLocation, {
            position: 'top-right',
            effect: 'slide',
            timeout: 5000,
            customFields: {
                messageItem: 2,
                showIconClosed: true,
                icon: "las la-2x la-exclamation-triangle"
            }
        });
        let filtroEntitySeleccionado = {
            ...this.state.filtroEntitySeleccionado, geo: {
                userLocation: {
                    queryCercaDeMi: false
                }
            },
        }
        //console.log("EntityListPage::onChangeFilter() -> call changefiltroEntitySeleccionado");

        this.props.changefiltroEntitySeleccionado(filtroEntitySeleccionado);

        let elements = document.querySelectorAll(".buttonBuscarCerca >i")
        if (elements) {
            elements.forEach((element) => {
                element.classList.remove('spin');
                element.classList.remove('la-sync-alt');
                element.classList.add('la-crosshairs');
            })
        }
    }

    onClickPagination(pagNum) {
        // console.log("EntityListPage::onClickPagination()");
        if (this.state.config.pagNum !== pagNum) {
            // console.log("EntityListPage::onClickPagination(" + pagNum + ")");
            let request = {
                filter: this.state.filtroEntitySeleccionado, metadata: {
                    numElements: this.state.config.elementsPerPage, pagNum: pagNum,
                }
            };
            this.setState({
                ...this.state, pagNum: pagNum,
            })
            //console.log("EntityListPage::onClickPagination() -> call getEntitiesByFilter");
            this.props.getEntitiesByFilter(request)
            this.props.changeConfigFiltroEntity({...this.state.config, pagNum: pagNum})
            this.changePath(this.state.filtroEntitySeleccionado, {pagNum: pagNum})
            sendEvent(TIPOS_EVENTOS.SEARCH, ELEMENTS.BUSCADOR.BUSCADOR, {
                ...request, config: {
                    mobileMode: this.state.config.mobileMode,
                    showMap: this.state.config.showMap,
                    showListing: this.state.config.showListing
                }
            })

        }
    }

    onSearchInBoundsLocation(boundsObj) {

        let filtroEntitySeleccionado = {
            ...this.state.filtroEntitySeleccionado, geo: {
                userLocation: undefined, geoInBounds: {
                    useGeoInBounds: true, bounds: boundsObj.bounds, center: boundsObj.center
                }, provincia: undefined, municipio: undefined
            },
        }
        //console.log("filtroEntitySeleccionado");
        //console.log(filtroEntitySeleccionado);

        let request = {
            filter: filtroEntitySeleccionado, metadata: {
                numElements: this.state.config.elementsPerPage, pagNum: this.state.config.pagNum,
            }
        };
        //console.log("EntityListPage::onSearchInBoundsLocation() -> call getEntitiesByFilter");
        this.props.getEntitiesByFilter(request)
        //console.log("EntityListPage::onChangeFilter() -> call changefiltroEntitySeleccionado");

        this.props.changefiltroEntitySeleccionado(filtroEntitySeleccionado);
        sendEvent(TIPOS_EVENTOS.SEARCH, ELEMENTS.BUSCADOR.BUSCADOR, {
            ...request, config: {
                mobileMode: this.state.config.mobileMode,
                showMap: this.state.config.showMap,
                showListing: this.state.config.showListing
            }
        })

    }

    onClickCardListing(idClick) {
        console.log("EntityListPage::onClickCardListing()");
        console.log("idClick = '" + idClick + "'");
        // console.log("posicion = '" + posicion + "'");
        sendEvent(TIPOS_EVENTOS.CLIC, ELEMENTS.BUSCADOR.ENTITY, {
            idClick: idClick,
            clicOn: ELEMENTS.BUSCADOR.LISTING
        })
    }

    onClickCardMap(idClick) {
        console.log("EntityListPage::onClickCardMap()");
        console.log("idClick = '" + idClick + "'");
        // console.log("posicion = '" + posicion + "'");
        sendEvent(TIPOS_EVENTOS.CLIC, ELEMENTS.BUSCADOR.ENTITY, {
            idClick: idClick,
            clicOn: ELEMENTS.BUSCADOR.MAP
        })
    }

    onMouseOverElement(id) {
        // console.log("EntityListPage::onMouseOverElement() -> " + id);
        this.setState({
            currentElementHoverId: id
        })

    }


    createBreadcrumbs(currentFilter, dataFilterNormaliced) {
        let arrayList = []
        let lastElement
        let showBreadcrumbs = true;
        let currentTipo = (currentFilter?.tipo?.length === 1) ? currentFilter?.tipo[0] : currentFilter?.tipo?.join(', ').replace(/,(?!.*,)/gmi, ' y');
        let currentTipoNorm = dataFilterNormaliced.tipo
        let currentSubtipo = currentFilter?.subtipo
            ?.map(subtipo => MAP_SUBTIPOS_ENTITY_CONFIG[currentFilter?.tipo][subtipo].label)

        let currentSubtipoNorm = currentSubtipo
            .map(plurifyFirstWord)
            .join(', ').replace(/,(?!.*,)/gmi, ' y');


        const currentProvincia = currentFilter?.geo?.provincia
        const currentProvinciaNorm = (currentProvincia) ? this.props.paramsFilter?.provincias?.filter(prov => prov.value === currentProvincia)[0]?.label : undefined
        let currentMunicipio
        let currentMunicipioNorm

        if (currentFilter?.geo?.municipio && currentProvincia && (!this.props?.paramsFilter?.municipios || !this.props?.paramsFilter?.municipios[currentProvincia]?.length > 0)) {
            this.props.loadMunicipiosByProvincia(currentProvincia)
        } else {
            currentMunicipio = currentFilter?.geo?.municipio
            currentMunicipioNorm = (currentMunicipio) ? this.props.paramsFilter?.municipios[currentProvincia]?.filter(mun => mun.value === currentMunicipio)[0]?.label : undefined
        }

        arrayList.push({title: "Buscador Pet Friendly", path: PATH_BUSCADOR_PETFRIENDLY_ROOT})

        //tipo subtipo prov
        //tipo subtipo prov mun
        if (currentTipo && currentSubtipoNorm && currentProvincia) {
            arrayList.push({
                title: "En " + currentProvinciaNorm, path: PATH_BUSCADOR_PETFRIENDLY_PROVINCIA
                    .replace(":provincia", currentProvincia)
            })
            if (currentMunicipio) {
                arrayList.push({
                    title: "Cerca de " + currentMunicipioNorm, path: PATH_BUSCADOR_PETFRIENDLY_PROVINCIA_MUNICIPIO
                        .replace(":provincia", currentProvincia)
                        .replace(":municipio", currentMunicipio)
                })
            }
            let pathAux = PATH_BUSCADOR_PETFRIENDLY_TIPO_PROVINCIA_MUNICIPIO;
            if (currentProvincia) pathAux = pathAux.replace(":provincia", currentProvincia)
            if (currentMunicipio) pathAux = pathAux.replace(":municipio", currentMunicipio)
            if (currentTipo) pathAux = pathAux.replace(":tipo_entity", currentTipo)
            pathAux = pathAux.replace(/\/[a-z-]*:[a-z_]*/gmi, "")
            arrayList.push({
                title: currentTipoNorm, path: pathAux
            })
            lastElement = currentSubtipoNorm

        }

        //tipo
        //tipo subtipo
        if (currentTipo && !currentProvincia && !currentMunicipio) {
            if (currentSubtipoNorm) {
                let pathAux = PATH_BUSCADOR_PETFRIENDLY_TIPO;
                if (currentTipo) pathAux = pathAux.replace(":tipo_entity", currentTipo)
                pathAux = pathAux.replace(/\/[a-z-]*:[a-z_]*/gmi, "")
                arrayList.push({
                    title: currentTipoNorm, path: pathAux
                })
                lastElement = currentSubtipoNorm
            } else {
                lastElement = currentTipoNorm
                showBreadcrumbs = false
            }
        }

        //tipo prov
        //tipo prov mun
        if (currentTipo && !currentSubtipoNorm && currentProvincia) {
            // console.log("path -> tipo provincia ");
            if (currentProvincia) {
                arrayList.push({
                    title: "En " + currentProvinciaNorm, path: PATH_BUSCADOR_PETFRIENDLY_PROVINCIA
                        .replace(":provincia", currentProvincia)
                })
            }
            if (currentMunicipio) {
                // console.log("path -> tipo provincia municipio");
                arrayList.push({
                    title: "Cerca de " + currentMunicipioNorm, path: PATH_BUSCADOR_PETFRIENDLY_PROVINCIA_MUNICIPIO
                        .replace(":provincia", currentProvincia)
                        .replace(":municipio", currentMunicipio)
                })
            }

            lastElement = currentTipoNorm
        }

        //prov
        //prov mun
        if (!currentTipo && !currentSubtipoNorm && currentProvincia) {
            if (currentMunicipio) {

                arrayList.push({
                    title: "En " + currentProvinciaNorm, path: PATH_BUSCADOR_PETFRIENDLY_PROVINCIA
                        .replace(":provincia", currentProvincia)
                })

                lastElement = "Cerca de " + currentMunicipioNorm
            } else {
                lastElement = "En " + currentProvinciaNorm
            }
        }
        if (currentFilter?.geo?.userLocation?.useUserLocation) {
            lastElement += " cerca de mi"
            showBreadcrumbs = true
        }

        return {
            listBreadcrumbs: arrayList, lastElement: lastElement, show: showBreadcrumbs
        }
    }

    desnormalizeDataFilter(currentFilter, entities) {
        const totalRecords = entities.totalRecords
        let currentTipo = (currentFilter?.tipo?.length === 1) ? currentFilter?.tipo[0] : currentFilter?.tipo?.join(', ').replace(/,(?!.*,)/gmi, ' y');
        let currentTipDesnorm
        if (currentTipo) currentTipDesnorm = plurifyFirstWord(capitalizeFirstLetter(MAP_TIPOS_ENTITY[currentTipo].longLabel))
        let currentSubtipoDesnorm = currentFilter?.subtipo
            .map((subtipo, index, {length}) => {
                const subt = MAP_SUBTIPOS_ENTITY_CONFIG[currentFilter?.tipo][subtipo]
                if (length - 1 === index) return totalRecords === 1 ? subt.longLabel : plurifyFirstWord(subt.longLabel);
                return totalRecords === 1 ? subt.label : plurifyFirstWord(subt.label);
            })
            .join(', ').replace(/,(?!.*,)/gmi, ' y');


        const currentProvincia = currentFilter?.geo?.provincia
        const currentProvinciaDesnorm = (currentProvincia) ? this.props.paramsFilter?.provincias?.filter(prov => prov.value === currentProvincia)[0]?.label : undefined

        let currentMunicipioDesnorm
        if (currentFilter?.geo?.municipio && currentProvincia && (!this.props?.paramsFilter?.municipios || !this.props?.paramsFilter?.municipios[currentProvincia]?.length > 0)) {
            // console.log("No hay municipios de provincia[" + currentProvincia + "] en config -> pidiendo");
            this.props.loadMunicipiosByProvincia(currentProvincia)
        } else {
            let currentMunicipio = currentFilter?.geo?.municipio
            currentMunicipioDesnorm = (currentMunicipio) ? this.props.paramsFilter?.municipios[currentProvincia]?.filter(mun => mun.value === currentMunicipio)[0]?.label : undefined
        }

        return {
            tipo: currentTipDesnorm,
            subtipo: currentSubtipoDesnorm,
            municipio: currentMunicipioDesnorm,
            provincia: currentProvinciaDesnorm,
        }
    }


    formatTitleFromFilter(currentFilter, entities, dataFilterNormaliced) {
        const totalRecords = entities.totalRecords

        let resultsOnLocation = false
        if (currentFilter.geo.municipio) {
            resultsOnLocation = entities.list.some(entity => entity.direccion.municipio === dataFilterNormaliced.municipio)
        }
        let tipoSubtipoActivo = (dataFilterNormaliced.subtipo) ? dataFilterNormaliced.subtipo : dataFilterNormaliced.tipo
        let arrayDistancias
        if (currentFilter.geo?.geoInBounds?.useGeoInBounds) {
            arrayDistancias = entities.list.map((entity) => {
                const distancia = coordsDistance(currentFilter.geo.geoInBounds.center.latLng.lng, currentFilter.geo.geoInBounds.center.latLng.lat, entity.direccion.location.coordinates[0], entity.direccion.location.coordinates[1])

                return {municipio: entity.direccion.municipio, distance: distancia}
            }).filter((value, index, self) => index === self.findIndex(elem => elem.municipio === value.municipio)).sort((a, b) => b.distance - a.distance);
        }

        let lugar = "";

        if (currentFilter?.geo?.userLocation?.useUserLocation || currentFilter?.geo?.userLocation?.queryCercaDeMi) {
            lugar = " cerca de mi"
        } else if (currentFilter?.geo?.municipio && dataFilterNormaliced?.municipio) {
            if (resultsOnLocation) lugar = " en " + dataFilterNormaliced.municipio
            else lugar = " cerca de " + dataFilterNormaliced.municipio

        } else if (currentFilter?.geo?.provincia && dataFilterNormaliced?.provincia) {
            lugar = " en " + dataFilterNormaliced.provincia
        } else {
            lugar = " en la zona de busqueda"
        }
        return "" + totalRecords + " " + tipoSubtipoActivo + lugar
    }


    createMetaTags(currentFilter, entities, dataFilterNormaliced) {
        const totalRecords = entities.totalRecords
        const metaTags = {}
        let resultsOnLocation = false
        if (currentFilter.geo.municipio) {
            resultsOnLocation = entities.list.some(entity => entity.direccion.municipio === dataFilterNormaliced.municipio)
        }

        let tipoSubtipoActivo = (dataFilterNormaliced.subtipo) ? dataFilterNormaliced.subtipo : dataFilterNormaliced.tipo
        let arrayDistancias
        if (currentFilter.geo?.geoInBounds?.useGeoInBounds) {
            arrayDistancias = entities.list.map((entity) => {
                const distancia = coordsDistance(currentFilter.geo.geoInBounds.center.latLng.lng, currentFilter.geo.geoInBounds.center.latLng.lat, entity.direccion.location.coordinates[0], entity.direccion.location.coordinates[1])

                return {municipio: entity.direccion.municipio, distance: distancia}
            }).filter((value, index, self) => index === self.findIndex(elem => elem.municipio === value.municipio)).sort((a, b) => b.distance - a.distance);
            // ).sort((a,b) => a.distance - b.distance );
        }


        let lugarStr = "";
        //TODO 10/3/22 23:20: aqui hay que contrir las frases usando las palabras clave pj:"sitios petfrindy en madrid" o csoas así, cada uno con su casuistica
        if (currentFilter?.geo?.userLocation?.useUserLocation) {
            lugarStr = " cerca de mi"
        } else if (currentFilter?.geo?.municipio) {
            lugarStr = " cerca de " + dataFilterNormaliced.municipio
        } else if (currentFilter?.geo?.provincia) {
            lugarStr = " en " + dataFilterNormaliced.provincia
        } else if (currentFilter?.geo?.geoInBounds?.useGeoInBounds) {
            lugarStr = " en la zona de búsqueda"
        } else {
            lugarStr = " de España"
        }

        if (currentFilter?.tipo?.length === 1 && currentFilter?.tipo[0] === "protectora") {
            if (tipoSubtipoActivo === undefined) tipoSubtipoActivo = "Protectoras"
            metaTags.title = "🏡 LAS " + totalRecords + " MEJORES " + (tipoSubtipoActivo) + lugarStr + "【 2023 】" + ((dataFilterNormaliced.municipio === undefined || dataFilterNormaliced.municipio === dataFilterNormaliced.provincia) ? "" : "en " + dataFilterNormaliced.provincia + " ") + "| Adopta un Animal❕"

            if (!dataFilterNormaliced.municipio && !dataFilterNormaliced.provincia) metaTags.description = "Las mejores " + (tipoSubtipoActivo) + " de España" + ": Adopción de perros y gatos en España. Adopciones en protectoras como " + (entities.list.slice(0, 6).map(e => e.nombre).join(', ').replace(/,(?!.*,)/gmi, ' y'))
            else metaTags.description = "Las mejores " + (tipoSubtipoActivo) + "" + lugarStr + ": Adopción de perros y gatos" + lugarStr + ". Adopciones en protectoras como " + (entities.list.slice(0, 6).map(e => e.nombre).join(', ').replace(/,(?!.*,)/gmi, ' y'))

        } else {
            metaTags.title = "🐶🐈 LOS " + totalRecords + " MEJORES sitios Pet Friendly " + lugarStr + "【 2023 】" + ((dataFilterNormaliced.municipio === undefined || dataFilterNormaliced.municipio === dataFilterNormaliced.provincia) ? "" : "en " + dataFilterNormaliced.provincia + " ") + "| Adopta un Animal❕"
            metaTags.description = "Los mejores sitios Pet Friendly de " + dataFilterNormaliced.municipio + ": Encuentra los mejores sitios pet friendly en la zona de " + dataFilterNormaliced.municipio + " en " + dataFilterNormaliced.provincia + " y reducir el abandono de animales"

            if (!dataFilterNormaliced.municipio && !dataFilterNormaliced.provincia) metaTags.description = "LOS MEJORES sitios Pet Friendly de España" + ": Adopción de perros y gatos en España. Adopciones en protectoras como " + (entities.list.slice(0, 6).map(e => e.nombre).join(', ').replace(/,(?!.*,)/gmi, ' y'))
            else metaTags.description = "LOS MEJORES sitios Pet Friendly " + lugarStr + ": Adopción de perros y gatos" + lugarStr + ". Adopciones en protectoras como " + (entities.list.slice(0, 6).map(e => e.nombre).join(', ').replace(/,(?!.*,)/gmi, ' y'))
        }

        return metaTags
    }

    buildFAQsList(currentFilter, entities, dataFilterNormaliced) {
        let lugarStrAnswer
        let lugarStrQuestion

        let pathTipoLoc = ""
        let pathCercaDeMi = ""


        if (currentFilter.geo?.userLocation?.useUserLocation) {
            lugarStrQuestion = " cerca de mi"
            lugarStrAnswer = " cerca de ti"
            pathTipoLoc = PATH_BUSCADOR_PETFRIENDLY_TIPO_SUBTIPO
                .replace(":tipo_entity", currentFilter?.tipo[0])
                .replace(":subtipo_entity", currentFilter?.subtipo[0])
                .replace(/\/((:[a-z]*_?[a-z]*)|(undefined))/gmi, "")
            pathCercaDeMi = pathTipoLoc + "/cerca-de-mi"
        } else if (currentFilter?.geo?.municipio) {
            lugarStrQuestion = " cerca de " + dataFilterNormaliced.municipio
            lugarStrAnswer = lugarStrQuestion
            // "/buscar-pet-friendly/:tipo_entitys/:subtipo_entity/en-:provincia/cerca-de-:municipio/";
            pathTipoLoc = PATH_BUSCADOR_PETFRIENDLY_TIPO_SUBTIPO_PROVINCIA_MUNICIPIO
                .replace(":tipo_entity", currentFilter?.tipo[0])
                .replace(":subtipo_entity", currentFilter?.subtipo[0])
                .replace(":provincia", currentFilter.geo.provincia);

            pathCercaDeMi = pathTipoLoc.replace(":municipio", "mi")
                .replace(/\/((:[a-z]*_?[a-z]*)|(undefined))/gmi, "")

            pathTipoLoc = pathTipoLoc.replace(":municipio", currentFilter.geo.municipio)
                .replace(/\/((:[a-z]*_?[a-z]*)|(undefined))/gmi, "")


        } else if (currentFilter?.geo?.provincia) {
            lugarStrQuestion = " en " + dataFilterNormaliced.provincia
            lugarStrAnswer = lugarStrQuestion
            pathTipoLoc = PATH_BUSCADOR_PETFRIENDLY_TIPO_SUBTIPO_PROVINCIA
                .replace(":tipo_entity", currentFilter?.tipo[0])
                .replace(":subtipo_entity", currentFilter?.subtipo[0])
                .replace(":provincia", currentFilter.geo.provincia)
                .replace(/\/((:[a-z]*_?[a-z]*)|(undefined))/gmi, "")
            pathCercaDeMi = pathTipoLoc + "/cerca-de-mi"

        } else if (currentFilter?.geo?.geoInBounds?.useGeoInBounds) {
            lugarStrQuestion = " en la zona de búsqueda"
            lugarStrAnswer = lugarStrQuestion

            pathTipoLoc = PATH_BUSCADOR_PETFRIENDLY_TIPO_SUBTIPO
                .replace(":tipo_entity", currentFilter?.tipo[0])
                .replace(":subtipo_entity", currentFilter?.subtipo[0])
                .replace(/\/((:[a-z]*_?[a-z]*)|(undefined))/gmi, "")
            pathCercaDeMi = pathTipoLoc + "/cerca-de-mi"

        } else {
            lugarStrQuestion = " de España"
            lugarStrAnswer = lugarStrQuestion

            pathTipoLoc = PATH_BUSCADOR_PETFRIENDLY_TIPO_SUBTIPO
                .replace(":tipo_entity", currentFilter?.tipo[0])
                .replace(":subtipo_entity", currentFilter?.subtipo[0])
                .replace(/\/((:[a-z]*_?[a-z]*)|(undefined))/gmi, "")
            pathCercaDeMi = pathTipoLoc + "/cerca-de-mi"

        }


        let tipoSubtipoActivo = (dataFilterNormaliced.subtipo) ? dataFilterNormaliced.subtipo : dataFilterNormaliced.tipo

        let titleFAQs
        if (currentFilter?.tipo[0] === "protectora") {
            titleFAQs = "Preguntas frecuentes sobre " + tipoSubtipoActivo + " de animales " + lugarStrAnswer
        } else {
            titleFAQs = "Preguntas frecuentes" + lugarStrAnswer
        }

        let listFAQs
        if (currentFilter?.tipo[0] === "protectora") {
            listFAQs = [{
                question: "¿Cuáles son las <strong>" + tipoSubtipoActivo + " de animales</strong> que hay <strong>" + lugarStrQuestion + "</strong>?",
                answer: "Si buscas adoptar un animal <strong>" + lugarStrAnswer + "</strong>, plantéate visitar estas <strong>" + tipoSubtipoActivo + " de animales</strong>: " + (entities.list.slice(0, 3).map(e => '<a rel="follow" target="_black" href="' + process.env.HOST_ADOPTA + PATH_BUSCADOR_PETFRIENDLY_DETAIL_PERMALINK_PATTERN.replace(":tipo_entity", e.tipo).replace(":permalink", e.permalink) + '">' + e.nombre + "</a>")).join(', ').replace(/,(?!.*,)/gmi, ' y') + ", ya que son las más recomendadas por los usuarios de ADOPTA®."
            }, {
                question: "¿Cuáles son las <strong>" + tipoSubtipoActivo + "</strong> más populares <strong>" + lugarStrQuestion + "</strong>?",
                answer: "Según los usuarios de ADOPTA® y sus visitas estas son algunas de las <strong>" + tipoSubtipoActivo + " de animales</strong> más populares <strong>" + lugarStrAnswer + "</strong> donde puedes adoptar un perro o un gato:" + "<ul>" + (entities.list.slice(0, 3).map(e => '<li><a rel="follow" target="_black" href="' + process.env.HOST_ADOPTA + PATH_BUSCADOR_PETFRIENDLY_DETAIL_PERMALINK_PATTERN.replace(":tipo_entity", e.tipo).replace(":permalink", e.permalink) + '">' + e.nombre + "</a></li>").join("")) + "</ul>"
            }, {
                question: "¿Cuánto cuesta adoptar un perro o gato en una <strong>" + tipoSubtipoActivo + "</strong><strong>" + lugarStrQuestion + "</strong>? ",
                answer: "<ul><li>El coste medio para <strong>adoptar un perro</strong> en una <strong>" + tipoSubtipoActivo + " de animales</strong> <strong>" + lugarStrAnswer + "</strong> oscila entre los 180€ para cachorros menores de 6 meses y los 100€ para perros adultos. Perros mayores de más de 10 años a menudo es a la voluntad.</li> <li> Y el coste medio para <strong>adoptar un gato</strong> <strong>" + lugarStrAnswer + "</strong> oscila entre los 50€ si es cachorro y los 130€ si es un gato adulto.</li></ul> Todos los animales se suelen entregan con sus vacunas al día, esterilizados si son adultos, desparasitados interna y externamente y con el microchip. Este coste suele incluir una revisión veterinaria completa para asegurarse de que el animal está sano antes de la adopción y algunos gastos de haberlos estado cuidando y una ayuda para seguir con su labor"
            }, {
                question: "¿Dónde adoptar un perro<strong>" + lugarStrQuestion + "</strong>?",
                answer: "Según los usuarios de ADOPTA®, estas son algunas de las <strong>" + tipoSubtipoActivo + " de animales </strong> donde puedes adoptar un perro <strong>" + lugarStrAnswer + "</strong>: " + (entities.list.slice(0, 5).sort((a, b) => 0.5 - Math.random()).map(e => '<a rel="follow" target="_black" href="' + process.env.HOST_ADOPTA + PATH_BUSCADOR_PETFRIENDLY_DETAIL_PERMALINK_PATTERN.replace(":tipo_entity", e.tipo).replace(":permalink", e.permalink) + '">' + e.nombre + "</a>")).join(', ').replace(/,(?!.*,)/gmi, ' y') + ". <br>Descubre todas las <strong>" + tipoSubtipoActivo + '</strong> en: <a rel="follow" target="_black" href="' + pathTipoLoc + '">' + tipoSubtipoActivo + ' de animales <strong>' + lugarStrAnswer + '</strong> </a>.'
            }, {
                question: "¿Dónde adoptar un gato<strong>" + lugarStrQuestion + "</strong>?",
                answer: "Según los usuarios de ADOPTA®, estas son algunas de las <strong>" + tipoSubtipoActivo + " de animales </strong> donde puedes adoptar un gato <strong>" + lugarStrAnswer + "</strong>: " + (entities.list.slice(0, 5).sort((a, b) => 0.5 - Math.random()).map(e => '<a rel="follow" target="_black" href="' + process.env.HOST_ADOPTA + PATH_BUSCADOR_PETFRIENDLY_DETAIL_PERMALINK_PATTERN.replace(":tipo_entity", e.tipo).replace(":permalink", e.permalink) + '">' + e.nombre + "</a>")).join(', ').replace(/,(?!.*,)/gmi, ' y') + ". <br>Descubre todas las <strong>" + tipoSubtipoActivo + '</strong> en: <a rel="follow" target="_black" href="' + pathTipoLoc + '">' + tipoSubtipoActivo + '  de animales <strong>' + lugarStrAnswer + '</strong> </a>.'
            }, {
                question: "¿Dónde me recomendáis que vaya a adoptar un animal <strong>" + lugarStrQuestion + "</strong>?",
                answer: "Si quieres adoptar un animal <strong>" + lugarStrAnswer + "</strong> algunas de las <strong>" + tipoSubtipoActivo + " </strong> más cercanas que han indicado los usuarios de ADOPTA® son:" + "<ul>" + (entities.list.slice(0, 3).map(e => '<li><a rel="follow" target="_black" href="' + process.env.HOST_ADOPTA + PATH_BUSCADOR_PETFRIENDLY_DETAIL_PERMALINK_PATTERN.replace(":tipo_entity", e.tipo).replace(":permalink", e.permalink) + '">' + e.nombre + "</a></li>").join("")) + "</ul>"
            }, {
                question: "¿Cómo puedo encontrar <strong>" + tipoSubtipoActivo + " de animales</strong> cerca de mí?",
                answer: "Echa un vistazo a nuestro completo mapa de <strong>" + tipoSubtipoActivo + " de animales </strong> y encuentra las" + ' <a rel="follow" target="_blanck" href="' + pathCercaDeMi + '">' + tipoSubtipoActivo + " de animales que hay cerca de ti.</a>"
            },

            ]
        }

        return {
            title: titleFAQs, listFAQs: listFAQs
        }
    }

    onClickShareButton(socialMedia) {
        sendEvent(TIPOS_EVENTOS.SHARE, ELEMENTS.BUSCADOR.BUSCADOR, {
            permalink: this.props.location.pathname, sharedOn: socialMedia
        })
    }

    render() {
        //console.log("EntityListPage::render() -> subtipo = '" + this.state?.filtroEntitySeleccionado?.subtipo + "'");

        let userLocation
        let geoInBounds
        // if (this.props.entities && this.state.filtroEntitySeleccionado && this.state.filtroEntitySeleccionado.userLocation && this.state.filtroEntitySeleccionado.userLocation.useUserLocation) {
        if (this.props.entities && this.state.filtroEntitySeleccionado?.geo?.userLocation?.useUserLocation) {
            userLocation = this.state.filtroEntitySeleccionado.geo.userLocation;
            geoInBounds = {
                useGeoInBounds: false,
            }
        } else if (this.props.entities && this.state.filtroEntitySeleccionado?.geo?.geoInBounds?.useGeoInBounds) {
            geoInBounds = this.state.filtroEntitySeleccionado.geo.geoInBounds;
        }

        let dataFilterNormaliced = this.desnormalizeDataFilter(this.props.filtroEntitySeleccionado, this.props.entities)
        const breadcrumbsObj = this.createBreadcrumbs(this.state.filtroEntitySeleccionado, dataFilterNormaliced)
        let titlePage = this.formatTitleFromFilter(this.props.filtroEntitySeleccionado, this.props.entities, dataFilterNormaliced)
        let metaTags = this.createMetaTags(this.props.filtroEntitySeleccionado, this.props.entities, dataFilterNormaliced)

        const FAQsObj = this.buildFAQsList(this.props.filtroEntitySeleccionado, this.props.entities, dataFilterNormaliced)

        return (<div>
            <Helmet>
                <title>{metaTags.title}</title>
                <meta name="description" content={metaTags.description}/>
                <meta property="og:title" content={metaTags.title}/>
                <meta property="og:description" content={metaTags.description}/>
                <meta name="twitter:description" content={metaTags.description}/>
            </Helmet>
            <Head
                previousPath={"adoptar"}
            />
            {this.props.showWaitBlock && <WaitBlock
                message={"Espere por favor..."}
                methodChange={this.EventWaitBlock}
            />}
            <div id="animals-list" className="container main-content">
                {/*<div>Ver {(this.props.totalRecordProtectora === 1)? this.props.totalRecordProtectora +" resultado": this.props.totalRecordProtectora +" resultados"}</div>*/}
                {breadcrumbsObj &&

                    <Breadcrumbs_component
                        listBreadcrumbs={breadcrumbsObj.listBreadcrumbs}
                        lastElement={breadcrumbsObj.lastElement}
                        showBreadcrumbs={breadcrumbsObj.show}
                        HOST={process.env.HOST_ADOPTA}
                        currentPath={this.props.location.pathname}
                        mobileMode={this.state.config.mobileMode}
                    />}
                <div className="cardInfoTitle">
                    <h1 className="">
                        {titlePage}
                    </h1>
                </div>
                <EntityListContainer
                    config={this.state.config}
                    entities={this.props.entities}
                    filtroEntitySeleccionado={this.state.filtroEntitySeleccionado}
                    paramsFilter={this.props.paramsFilter}
                    elementsPerRow={this.state.config.elementsPerRow}
                    elementsPerPage={this.state.config.elementsPerPage}
                    currentElementHoverId={this.state.currentElementHoverId}
                    onChangeFilter={this.onChangeFilter}
                    showLoader={this.showLoader}
                    onClickPagination={this.onClickPagination}
                    onSearchCurrentLocation={this.onSearchCurrentLocation}
                    onSearchInBoundsLocation={this.onSearchInBoundsLocation}
                    onShowMap={this.onShowMap}
                    onShowListing={this.onShowListing}
                    onMouseOverElement={this.onMouseOverElement}
                    onClickCardListing={this.onClickCardListing}
                    onClickCardMap={this.onClickCardMap}


                    userLocation={userLocation}
                    geoInBounds={geoInBounds}
                />
                <Alert stack={true} html={true} contentTemplate={AlertsConteiner}/>
            </div>
            {this.state.config.showListing && <div className={"faqs-listing col-lg-10"}>
                <AdsManagerContainer type={ADS_TYPES.BILLBOARD} />
                <FAQs_component
                    title={FAQsObj.title}
                    listQuestions={FAQsObj.listFAQs}
                    config={{
                        mobileMode: this.props.config.mobileMode, smallInDesk: true
                    }}
                />
                <AdsManagerContainer type={ADS_TYPES.MEGABANNER}/>
            </div>}
            <ShareButtonsBox
                shareURL={process.env.HOST_ADOPTA + this.props.location.pathname}
                text={""}
                hashtags={["AdoptaNoCompres"]}
                onClickShareButton={this.onClickShareButton}
                stickyMode
            />
            <div id="div-space-buttom"></div>
            {this.state.config.showListing && <Footer
                percent={100}
                configFooter={{"moreInfo": false}}
            />}
        </div>);
    }

    handleWindowResize() {
        // console.log("EntityListPage::handleWindowResize()");
        const width = window.innerWidth;
        let showListing, showMap
        if (this.state.config.showMap) {
            showListing = false;
            showMap = true;
        } else {
            showListing = true;
            showMap = false;
        }

        let newConfig = {}
        if (width < MOBILE_MAX_WINDOW_WIDTH) {
            newConfig = {
                elementsPerPage: ELEMENTS_PER_PAGE_MOBILE,
                elementsPerRow: ELEMENTS_PER_ROW_MOBILE,
                showListing: showListing,
                showMap: showMap,
                mobileMode: true
            }
        } else if (width >= MOBILE_MAX_WINDOW_WIDTH && width < TABLET_MAX_WINDOW_WIDTH) {
            newConfig = {
                elementsPerPage: ELEMENTS_PER_PAGE_TABLET,
                elementsPerRow: ELEMENTS_PER_ROW_TABLET,
                showListing: showListing,
                showMap: showMap,
                mobileMode: true

            }
        } else {
            newConfig = {
                elementsPerPage: ELEMENTS_PER_PAGE_DESKTOP,
                elementsPerRow: ELEMENTS_PER_ROW_DESKTOP,
                showListing: true,
                showMap: true,
                mobileMode: false
            }
        }
        // console.log("_.isEqual(this.state.config, newConfig) = '" + (_.isEqual(this.state.config, newConfig)) + "'");
        if (_.isEqual(this.state.config, newConfig)) {
            // console.log("Son iguales -> no hacer nada");
        } else {
            // console.log("son distintos -> cambiar state");
            this.setState({
                config: newConfig
            }, () => {
                // console.log("EntityListPage::handleWindowResize() -> State cambiado");
                this.props.changeConfigFiltroEntity(this.state.config);
            })
        }

    }

    componentWillMount() {
        if (!this.props?.paramsFilter?.provincias?.length > 0) {
            this.props.loadProvincias()
        }
        if (this.props.filtroEntitySeleccionado?.geo?.provincia && (!this.props?.paramsFilter?.municipios || !this.props?.paramsFilter?.municipios[this.props.filtroEntitySeleccionado?.geo?.provincia]?.length > 0)) {
            this.props.loadMunicipiosByProvincia(this.props.filtroEntitySeleccionado?.geo?.provincia)
        }
    }

    componentWillUpdate(nextProps, nextState, nextContext) {
        if (!_.isEqual(nextProps.params, this.props.params)) {
            this.loadFilterSeleccionadoFromURLParams(nextProps.params)
            this.props.changefiltroEntitySeleccionado(this.state.filtroEntitySeleccionado);

            let request = {
                filter: this.state.filtroEntitySeleccionado,
                metadata: {
                    numElements: this.state.config.elementsPerPage,
                    pagNum: this.state.config.pagNum,
                }
            };
            this.props.getEntitiesByFilter(request)
        }
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleWindowResize)

    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        if (this.state.config && (this.props.pagNum !== prevProps.pagNum)) {
            this.setState({
                config: {
                    pagNum: this.props.pagNum
                }
            })
        }
        if (!_.isEqual(this.props.filtroEntitySeleccionado, this.state.filtroEntitySeleccionado)) {
            this.setState({
                filtroEntitySeleccionado: this.props.filtroEntitySeleccionado
            })
        }
        if (this.props.filtroEntitySeleccionado?.geo?.provincia && this.props.filtroEntitySeleccionado.geo.provincia !== prevProps.filtroEntitySeleccionado?.geo?.provincia) {

            this.props.loadMunicipiosByProvincia(this.props.filtroEntitySeleccionado.geo.provincia)
        }

        if (!_.isEqual(this.props.config, this.state.config)) {
            this.setState({
                config: this.props.config
            })
        }


        if (!arrayEquals(prevProps.entities?.list, this.props.entities?.list) && this.props.entities?.list?.length > 0) {
            sendEvent(TIPOS_EVENTOS.IMPRESION, ELEMENTS.BUSCADOR.ENTITY, {list: this.props.entities?.list.map((e) => e._id)})
        }

        if (this.props?.filtroEntitySeleccionado?.geo?.userLocation?.useUserLocation) {
            let elements = document.querySelectorAll(".buttonBuscarCerca >i")
            if (elements) {
                elements.forEach((element) => {
                    element.classList.remove('spin');
                    element.classList.remove('la-sync-alt');
                    element.classList.add('la-crosshairs');
                })
            }
        }

        if (this.props.errorFiltro) {
            if (!_.isEqual(this.props.errorFiltro, prevProps.errorFiltro)) {
                // console.log("El error de filtro es distinto al anterior");
                const metadata = {
                    numElements: this.state.config.elementsPerPage, pagNum: this.state.config.pagNum,
                }
                //
                this.props.resetFilterEntities();
                this.props.getAllEntities(metadata)
                //TODO 18/3/22 12:14: se podría mejorar viendo cual es el error
                console.log("to /buscar-pet-friendly");

                browserHistory.push(PATH_BUSCADOR_PETFRIENDLY_ROOT)

            } else {
                // console.log("el error de filtro no ha cambiado");
            }
        } else {
            // console.log("No hay error en el filtro");
        }

        if (this.props.entities) {
            // console.log("hay entities");
            // console.log("entities size -> " + this.props.entities.list.length);
        }

    }
}

function mapStateToProps(state) {
    return {
        entities: state.entities,
        config: state.filterEntities.config,
        filtroEntitySeleccionado: state.filterEntities.filtroEntitySeleccionado,
        errorFiltro: state.filterEntities.errorFiltro,
        paramsFilter: state.filterEntities.params,


        // animals: state.animals.list,
        // pagNum: state.animals.pagNum,
        elementsPerRow: state.animals.elementsPerRow,
        elementsPerPage: state.animals.elementsPerPage,
        avanzado: state.filtersControl.avanzado,
        showHead: state.structureControl.showHead,
        showWaitBlock: state.structureControl.showWaitBlock,
        stepWaitBlock: state.structureControl.stepWaitBlock
    }
}

//El primer parametro es el mapeo de las props y el segundo las acciones- luego se le coloca que componente se ejecuta
export default connect(mapStateToProps, {
    getEntitiesByFilter,
    getAllEntities,
    changefiltroEntitySeleccionado,
    loadProvincias,
    loadMunicipiosByProvincia,
    resetFilterEntities,
    changeConfigFiltroEntity,
})(EntityListPage)